import { Submit } from 'libs/form/Submit';
import { useTranslation } from 'libs/i18n';
import { Link } from 'libs/navigation';
import { ParamsType } from 'libs/navigation/types';
import { Stack, Typography } from 'libs/ui';

import { useFormContext } from '../../forms/orderForm';

import { FormFooterStyled } from './CreateOrderFormFooter.styles';

export interface CreateOrderFormFooterProps<Path extends string> {
  submitLabel: string;
  submitLoading?: boolean;
  backLink?: Path;
  backLinkParams?: ParamsType<Path> | undefined;
}

export const CreateOrderFormFooter = <Path extends string>({
  submitLabel,
  backLink,
  backLinkParams,
  submitLoading,
}: CreateOrderFormFooterProps<Path>) => {
  const { t } = useTranslation();

  const { submitDisabled } = useFormContext();

  return (
    <FormFooterStyled>
      <Stack
        alignItems="center"
        direction="row"
        justifyContent="flex-end"
        spacing={40}
        spacingMobile={24}
      >
        {backLink && (
          <Link params={backLinkParams} to={backLink}>
            <Typography variant="bodyBold">{t('common.back')}</Typography>
          </Link>
        )}
        <Submit
          disabled={submitDisabled}
          label={submitLabel}
          loading={submitLoading}
        />
      </Stack>
    </FormFooterStyled>
  );
};
